<template>
    <article v-if="newVehicle" class="vehicle-card"
        v-bind:class="{ isFeatured: featured, isListView: listView, unavailable: false }">
        <div class="thumb">
            <a :href="AdData.Path">
                <picture>
                    <img alt=" " v-if="hasVehiclePhoto()" :src="vehiclePhoto()">
                </picture>
            </a>
            <a class="tag" href="/carro/novo/assistente-de-pesquisa">Novos</a>
        </div>
        <div class="description ink-flex">
            <h3>
                <a :href="AdData.Path">{{ AdData.Vehicle.Brand }} {{ AdData.Vehicle.Model }}<span>{{ AdData.Vehicle.Version
                }}
                        {{ AdData.Vehicle.HP }}cv - {{ AdData.Vehicle.Doors }}p</span></a>
            </h3>
            <favorite-button v-on:SetFavoriteSuccess="OnSetFavorite($event)" :id-pub="AdData.AdvertId"
                :is-favorite="true"></favorite-button>
            <div class="features">
                <ul class="push-bottom">
                    <li>{{ AdData.Vehicle.Fuel }}</li>
                </ul>
                <div class="push-bottom">
                    <div v-if="AdData.ProcurementInfo != null" class="price">
                        <span class="old-price">{{
                            AdData.ProcurementInfo.OldPrice.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") }} €</span>
                        <span>{{ AdData.ProcurementInfo.NewPrice.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                        }}<small>€</small></span>
                    </div>
                    <div v-if="AdData.ProcurementInfo != null" data-toggle="tooltip" data-placement="top"
                        title="Validade da proposta" class="info">
                        Validade: {{ AdData.ProcurementInfo.ValidUntil | formatOnlyDate }}
                        <i class="far fa-question-circle"></i>
                    </div>
                    <div v-if="AdData.ProcurementInfo == null" class="price">
                        <span>{{ AdData.Price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") }}<small>€</small></span>
                    </div>
                </div>
            </div>
        </div>
    </article>

    <article v-else class="vehicle-card" v-bind:class="{ isFeatured: featured, isListView: listView, unavailable: false }">
        <div class="thumb">
            <a :href="AdData.Path">
                <picture>
                    <source :alt="`favorito`" :srcset="vehiclePhoto()" >
                    <img v-if="hasVehiclePhoto()" :alt="`favorito`" :src="vehiclePhoto()" />
                </picture>
            </a>
            <a class="tag" href="/carros-usados">Usados</a>
        </div>
        <div class="description ink-flex">
            <h3>
                <a :href="AdData.Path">{{ AdData.Vehicle.Brand }} {{ AdData.Vehicle.Model }}<span>{{AdData.Vehicle.Version}}
                        {{ AdData.Vehicle.HP }}cv - {{ AdData.Vehicle.Doors }}p</span></a>
            </h3>
            <favorite-button v-on:SetFavoriteSuccess="OnSetFavorite($event)" :id-pub="AdData.AdvertId"
                :is-favorite="true"></favorite-button>
            <div class="features">
                <ul class="push-bottom">
                    <li>{{ AdData.Vehicle.YearProduction }}</li>
                    <li>{{ AdData.Vehicle.Km.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".") }} km</li>
                    <li>{{ AdData.Vehicle.Fuel }}</li>
                </ul>
                <div class="push-bottom">
                    <div v-if="AdData.ProcurementInfo != null" class="price">
                        <span class="old-price">{{
                            AdData.ProcurementInfo.OldPrice.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") }} €</span>
                        <span>{{ AdData.ProcurementInfo.NewPrice.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                        }}<small>€</small></span>
                    </div>
                    <div v-if="AdData.ProcurementInfo != null" data-toggle="tooltip" data-placement="top"
                        title="Validade da proposta" class="info">
                        Validade: {{ AdData.ProcurementInfo.ValidUntil | formatOnlyDate }}
                        <i class="far fa-question-circle"></i>
                    </div>
                    <div v-if="AdData.ProcurementInfo == null" class="price">
                        <span>{{ formatPrice(AdData.Price) }}<small>€</small></span>
                    </div>

                </div>
            </div>
        </div>
    </article>
</template>

<script>

import FavoriteButton from './favorite-button.vue';
import '../scripts/filter.js'

export default {
    props: {
        newVehicle: Boolean,
        featured: Boolean,
        listView: Boolean,
        isFavorite: {
            type: Boolean,
            default: false
        },
        AdData: Object
    },
    components: {
        FavoriteButton
    },
    mounted() {
        
    },
    methods: {
        vehiclePhoto() {
            if (this.AdData.Vehicle.Photos == null) {
                if (this.AdData.Vehicle.Photo != null && !this.AdData.Vehicle.Photo.startsWith("image")){
                    return this.AdData.Vehicle.Photo;
                }
                return "/photo/" + this.AdData.Vehicle.Photo;
            }
            if (!this.AdData.Vehicle.Photos[0].startsWith("image")){
                return this.AdData.Vehicle.Photos[0];
            }
            return "/photo/" + this.AdData.Vehicle.Photos[0];
        },
        formatPrice(value) {
            return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
        },
        hasVehiclePhoto() {
            return this.AdData.Vehicle.Photo != null && this.AdData.Vehicle.Photo != "";
        },
        OnSetFavorite(e) {
            this.$emit('SetFavoriteSuccess', e);
        }
    }
};
</script>